/* istanbul ignore file */
/**
 * User
 */
export const SAVE_USER = 'SAVE_USER'

/**
 * Initial Lead Data
 */

export const SAVE_LEAD_ADDRESS = 'SAVE_LEAD_ADDRESS'

/**
 * Initial Lead Validations
 */

export const SAVE_LEAD_VALIDATIONS = 'SAVE_LEAD_VALIDATIONS'

/**
 * Feature Flags
 */
export const STORE_FEATURE_FLAGS = 'STORE_FEATURE_FLAGS'

/**
 * Analytics Config
 */
export const STORE_ANALYTICS_CONFIG = 'STORE_ANALYTICS_CONFIG'
